import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "@nuxtjs/composition-api";

import { useAmplitude, useFeatureDetection, useI18n, useLinkService, useTranslate } from "@/composables";
import { useCartsStore } from "@/store";
import { filterRemoveUndefined } from "@/utils/transform/array";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartsList',
  emits: ["close", "view", "showLoadingOverlay"],
  setup(__props, { emit }: { emit: ({
  (event: "close", value: boolean): void;
  (e: "view", cartId: string): void;
  (e: "showLoadingOverlay", show: boolean): void;
}), expose: any, slots: any, attrs: any }) {



const deleteCartConfirmation = ref(false);
const pendingDeleteCartId = ref<string | null>(null);
const isDeletingCart = ref(false);

const amplitude = useAmplitude();
const i18n = useI18n();
const featureDetection = useFeatureDetection();
const linkService = useLinkService();
const { tc } = useTranslate();

const cartsStore = useCartsStore();

const carts = computed(() => {
  return Object.values(cartsStore.carts)
    .filter(filterRemoveUndefined)
    .map((cart) => {
      return {
        id: cart.id,
        retailerName: cartsStore.retailers[cart.retailerId]?.displayName ?? "",
        retailerImageUrl: cartsStore.retailers[cart.retailerId]?.imageUrl ?? "",
        itemCount: tc(
          "{count} item | {count} items",
          cart.cartItemIds
            .map((cartItemId) => cartsStore.cartItems[cartItemId])
            .filter(filterRemoveUndefined)
            .reduce((prev, curr) => prev + curr.quantity, 0),
        ).value,
        subtotal: Intl.NumberFormat(i18n.locale, { style: "currency", currency: "USD" }).format(cart.subtotal),
      };
    });
});

const isEmpty = computed(() => carts.value.length === 0);

const pendingDeleteCartImageUrl = computed(() => {
  return carts.value.find((cart) => cart.id === pendingDeleteCartId.value)?.retailerImageUrl;
});

const imageProps = computed(() => {
  if (!pendingDeleteCartImageUrl.value) {
    return null;
  }
  const imageUrl = linkService.getImageLink({
    url: pendingDeleteCartImageUrl.value,
    width: "76",
    height: "76",
    useDefaultDpr: false,
  });
  return {
    src: imageUrl + `&dpr=${featureDetection.dpr}`,
    srcSet: `${imageUrl}&dpr=1 1x, ${imageUrl}&dpr=2 2x, ${imageUrl}&dpr=3 3x`,
    width: 76,
    height: 76,
    crossorigin: false,
    rounded: true,
  };
});

const onViewCart = (cartId: string) => {
  emit("view", cartId);
};

const onDeleteCart = (cartId: string) => {
  pendingDeleteCartId.value = cartId;
  deleteCartConfirmation.value = true;
};

const onDeleteCartConfirm = async () => {
  deleteCartConfirmation.value = false;
  isDeletingCart.value = true;
  emit("showLoadingOverlay", true);
  if (pendingDeleteCartId.value) {
    const cart = cartsStore.carts[pendingDeleteCartId.value];
    const retailerName = cartsStore.retailers[cart?.retailerId ?? ""]?.displayName;
    await cartsStore.deleteCarts({ ids: [pendingDeleteCartId.value] });
    amplitude?.sendEvent("/cart-deleted", {
      "advertiser-name": retailerName ?? "retailer",
    });
  }
  isDeletingCart.value = false;
  emit("showLoadingOverlay", false);
  pendingDeleteCartId.value = null;
};

return { __sfc: true,emit, deleteCartConfirmation, pendingDeleteCartId, isDeletingCart, amplitude, i18n, featureDetection, linkService, tc, cartsStore, carts, isEmpty, pendingDeleteCartImageUrl, imageProps, onViewCart, onDeleteCart, onDeleteCartConfirm }
}

})